module.exports = "{\r\n  id: 'c12',\r\n  type: 'column',\r\n  children: [\r\n    { /* tile layout here */ },\r\n    { /* another tile layout */}\r\n  ]\r\n}\r\n";


/*****************
 ** WEBPACK FOOTER
 ** ./snippets/wrapperLayout.html
 ** module id = 270
 ** module chunks = 0
 **/